import { Injectable } from '@angular/core';
import { TenantBenefitChildDetail } from '../../../shared/models/tenant-benefits/tenant-benefit-child-detail';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class HrBenefitDetailsCreateService {
  private readonly tenantBenefitChildDetailSource =
    new BehaviorSubject<TenantBenefitChildDetail | null>(null);
  public readonly tenantBenefitChildDetail$ = this.tenantBenefitChildDetailSource.asObservable();

  public setTenantBenefitChildDetail(data: Partial<TenantBenefitChildDetail>) {
    this.tenantBenefitChildDetailSource.next(data as TenantBenefitChildDetail);
  }
}
